module.exports = __webpack_public_path__ + "img/160c21d.png";